

























































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { sectionCoreProps } from '../mixins/sectionCore'
import { ButtonAction } from '../contracts/ButtonHeroAction'
import SectionBasic from '../components/SectionBasic.vue'
import BlockButtons from '../components/BlockButtons.vue'

export default defineComponent({
  name: 'SectionPulseGrid',
  components: { BlockButtons, SectionBasic },
  mixins: [sectionCoreProps],
  props: {
    actionButtons: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
    cardTitle1: {
      type: String,
      default: '',
    },
    cardTitle2: {
      type: String,
      default: '',
    },
    cardTitle3: {
      type: String,
      default: '',
    },
    cardDescription1: {
      type: String,
      default: '',
    },
    cardDescription2: {
      type: String,
      default: '',
    },
    cardDescription3: {
      type: String,
      default: '',
    },
    titleAs: {
      type: String,
      default: 'div',
    },
  },
  setup() {},
})
